import { API_BASE_URL } from '../config';

const IMAGE_API_URL = `${API_BASE_URL}/images.php`;

/**
 * Obtiene los encabezados de autorización con el token JWT.
 * @returns {object} Objeto de encabezados.
 */
function getAuthHeaders() {
  const token = localStorage.getItem('jwt_token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
}

export async function listImages() {
    const response = await fetch(`${IMAGE_API_URL}?action=list`, {
        method: 'GET',
        headers: getAuthHeaders()
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Error al listar imágenes.');
    }

    return response.json();
}

export async function uploadImage(file) {
    const formData = new FormData();
    formData.append('action', 'upload');
    formData.append('image', file);

    const response = await fetch(IMAGE_API_URL, {
        method: 'POST',
        headers: getAuthHeaders(), // Añadir encabezados de autorización
        body: formData
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Error al subir imagen.');
    }

    return response.json();
}

export async function deleteImage(imageId) {
    const response = await fetch(IMAGE_API_URL, {
        method: 'POST', // La API de imágenes usa POST para delete
        headers: {
            'Content-Type': 'application/json',
            ...getAuthHeaders() // Añadir encabezados de autorización
        },
        body: JSON.stringify({
            action: 'delete',
            image_id: imageId
        })
    });

    if (!response.ok) {
        const error = await response.json();
        throw new new Error(error.error || 'Error al eliminar imagen.');
    }

    return response.json();
}